import { useEffect } from 'react';

const SITE_URL = 'https://maseventos.co';
const DEFAULT_OG_IMAGE = `${SITE_URL}/imagenes/maseventos-og.png`;
const SITE_NAME = '+Eventos';
const SUFFIX = ' | +Eventos — Boletos para Eventos en Colombia';
const DEFAULT_DESC = 'Descubre y compra boletos para los mejores eventos en Colombia. Conciertos, teatro, festivales, deportes y más en +Eventos.';

/**
 * Actualiza title, meta description y Open Graph/Twitter meta tags.
 * @param {string} title - Titulo de la pagina
 * @param {string} [description] - Meta description
 * @param {string} [image] - URL de imagen OG (fallback: maseventos-og.png)
 */
export default function useSEO(title, description, image) {
  useEffect(() => {
    const fullTitle = title ? `${title}${SUFFIX}` : `${SITE_NAME}${SUFFIX}`;
    document.title = fullTitle;

    const desc = description || DEFAULT_DESC;
    // Si la imagen es relativa, hacerla absoluta
    let ogImage = image || DEFAULT_OG_IMAGE;
    if (ogImage && ogImage.startsWith('/')) {
      ogImage = `${SITE_URL}${ogImage}`;
    }

    // Helper: crear o actualizar una meta tag
    function setMeta(attr, key, value) {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    }

    // Description
    setMeta('name', 'description', desc);

    // Open Graph
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:image', ogImage);
    setMeta('property', 'og:url', window.location.href);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', SITE_NAME);

    // Twitter Card
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', desc);
    setMeta('name', 'twitter:image', ogImage);
    setMeta('name', 'twitter:card', 'summary_large_image');

    return () => {
      document.title = `${SITE_NAME}${SUFFIX}`;
      setMeta('property', 'og:title', `${SITE_NAME}${SUFFIX}`);
      setMeta('property', 'og:description', DEFAULT_DESC);
      setMeta('property', 'og:image', DEFAULT_OG_IMAGE);
      setMeta('name', 'twitter:title', `${SITE_NAME}${SUFFIX}`);
      setMeta('name', 'twitter:description', DEFAULT_DESC);
      setMeta('name', 'twitter:image', DEFAULT_OG_IMAGE);
    };
  }, [title, description, image]);
}
